<template>
    <v-dialog
            v-model="dialog"
            max-width="1000"
            :fullscreen="$vuetify.breakpoint.xsOnly"
    >
        <v-card>
            <v-card-text
                    :class="{
                        'pa-5': !$vuetify.breakpoint.xsOnly,
                        'c-pa-10': $vuetify.breakpoint.xsOnly
                    }"
            >
                <popup-header
                        :title="$t('msg.transferTasksToWeeklyPlan')"
                        class="mb-4"
                        @click-close="dialog = false"
                ></popup-header>
                <card-cols
                        :class="{'card-cols_only-right-column': $vuetify.breakpoint.smAndDown}"
                >
                    <template v-slot:left>
                        <plan
                                v-if="$vuetify.breakpoint.mdAndUp"
                                :items="items"
                                :remove="true"
                                :mark="false"
                                :task-icon="true"
                                @click-delete="deleteWeekPlan($event)"
                        ></plan>
                    </template>
                    <template v-slot:right>
                        <v-btn-toggle
                                v-model="tab"
                                mandatory
                                class="my-toggle"
                        >
                            <v-btn
                                    color="primary"
                                    key="monthly-plan"
                                    elevation="0"
                            >{{ $t('msg.fromMonthly') }}<br>{{ $t('msg.ofPlan') }}</v-btn>
                            <v-btn
                                    color="primary"
                                    key="projects"
                                    elevation="0"
                            >{{ $t('msg.fromProjects') }}</v-btn>
                        </v-btn-toggle>
                        <v-tabs-items
                                v-model="tab"
                                class="mt-4"
                        >
                            <v-tab-item
                                    key="monthly-plan"
                                    :transition="false"
                                    :reverse-transition="false"
                            >
                                <plan
                                        :items="monthPlans"
                                        :add="true"
                                        :mark="false"
                                        :task-icon="true"
                                        :selected-items="selectedMonthPlans"
                                        @click-arrow="addPlan($event)"
                                        :loading="loadingMonth"
                                ></plan>
                            </v-tab-item>
                            <v-tab-item
                                    key="projects"
                                    :transition="false"
                                    :reverse-transition="false"
                            >
                                <plan
                                        :items="projects"
                                        :add="true"
                                        :mark="false"
                                        :task-icon="true"
                                        type="projects"
                                        :selected-items="selectedTasks"
                                        @click-arrow="addTask($event)"
                                        :loading="loadingProject"
                                ></plan>
                            </v-tab-item>
                        </v-tabs-items>
                    </template>
                </card-cols>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import CardCols from "../../ui/CardCols";
    import Plan from "./Plan";
    import PopupHeader from "../../ui/PopupHeader";

    export default {
        components: {CardCols, Plan, PopupHeader},
        props: {
            items: Array
        },
        data() {
            return {
                dialog: false,
                tab: 'monthly-plan',
                monthPlans: [],
                projects: [],
                month: null,
                week: null,
                loadingMonth: false,
                loadingProject: false
            }
        },
        computed: {
            selectedTasks() {
                let ids = [];

                if (this.items !== undefined && this.items !== null) {
                    this.items.forEach(item => {
                        if (item.task_id !== undefined && typeof item.task_id === 'number' && item.task_id !== 0) {
                            ids.push(item.task_id);
                        }
                    });
                }

                return ids;
            },
            selectedMonthPlans() {
                let ids = [];

                if (this.items !== undefined && this.items !== null) {
                    this.items.forEach(item => {
                        if (item.month_plan_id !== undefined && typeof item.month_plan_id === 'number' && item.month_plan_id !== 0) {
                            ids.push(item.month_plan_id);
                        }
                    });
                }

                return ids;
            }
        },
        methods: {
            open(week, month) {
                this.week = week;
                this.month = month;
                this.tab = 'monthly-plan';
                this.dialog = true;
                this.loadProjects();
                this.loadMonthPlans();
            },
            loadMonthPlans() {
                this.loadingMonth = true;
                this.$store.dispatch('loadMonthPlans', {
                    params: {month: this.month}
                })
                    .then(res => this.monthPlans = res)
                    .finally(() => this.loadingMonth = false);
            },
            loadProjects() {
                this.loadingProject = true;
                this.$store.dispatch('loadProjects', {
                    with_tasks: true,
                    with_sub_tasks: true,
                    is_archive: false,
                    is_done: false,
                })
                    .then(res => this.projects = res)
                    .finally(() => this.loadingProject = false);
            },
            addPlan({project, task}) {
                let model = {
                    week: this.week,
                    project_id: !!project ? project.id : null,
                    task_id: !!task.task_id ? task.task_id : null,
                    note_id: task.note_id,
                    month_plan_id: task.id,
                    name: task.name
                };

                this.$store.dispatch('createWeekPlan', {data: model})
                    .then(() => {
                        this.$emit('saved');
                    });
            },
            addTask({project, task}) {
                let model = {
                    week: this.week,
                    project_id: project.id,
                    task_id: task.task_id,
                    note_id: task.task.note_id,
                    name: task.name
                };

                this.$store.dispatch('createWeekPlan', {data: model})
                    .then(() => {
                        this.$emit('saved');
                    });
            },
            deleteWeekPlan(weekPlanId) {
                this.$store.dispatch('deleteWeekPlan', {id: weekPlanId})
                    .then(() => {
                        this.$emit('saved');
                    });
            }
        }
    }
</script>